import {Flex, Text, useDisclosure} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IRestaurant} from 'types';
import ImageUI from 'ui/ImageUI';

import {ProviderDetailsModal} from '../..';

interface IProps {
  provider: IRestaurant;
  t: (term: TranslationKeys) => string;
}

export const ReviewsCount: FC<IProps> = ({t, provider}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();
  const {ratings} = provider;

  if (!ratings) return null;

  return (
    <Flex
      alignItems="center"
      borderRadius="16px"
      bg="#EECB11"
      px="15px"
      h={['24px', '36px']}
      ml="20px"
      mt={['0px', '5px']}
      cursor="pointer"
      onClick={onOpen}
      _hover={{color: colors.white}}
    >
      <ImageUI src="/star-default-icon.svg" w="15px" h="15px" alt="icon" />
      <Text fontSize={['11px', '16px']} ml="9px" mt="2px">
        {`${ratings.average.toFixed(2)} (${ratings.count})`}
      </Text>
      {isOpen && (
        <ProviderDetailsModal activeTab="review" provider={provider} isOpen={isOpen} onClose={onClose} t={t} />
      )}
    </Flex>
  );
};
